<template>
  <view class="accelerate-progress-wrapper" wx:style={{containerStyle}}>
    <view class="status-title">
      <hl-text
        text="{{title}}"
        commonStyle="{{commonStyle}}"
        hlStyle="{{hlStyle}}"
      />
    </view>
    <view class="status-bar">
      <view wx:for="{{statusList}}" class="status-item" wx:class="{{item.isActive && 'now'}}">
        <image class="icon" src="{{item.isActive? item.activeIcon:item.icon}}" mode="heightFix"/>{{ item.text }}
        <view class="line" wx:class="{{{white: currentStatus >= index + 1, now: item.isActive}}}" />
      </view>
    </view>
    <view class="progress-wrapper">
      <view class="progress-bar" wx:class="{{inited && 'transition'}}" wx:style="{{progressStyle}}">
        <image
          class="pic"
          wx:style="{{picStyle}}"
          src="https://ut-static.udache.com/webx/sfc/ChvHk36XRci9CdWj17fPy.gif"
          mode="{{mode}}"
        />
      </view>
    </view>
    <!-- 按钮操作区 -->
    <view class="btn-area" wx:if="{{!highest}}">
      <!-- 左侧邀请按钮 -->
      <view id="share-btn" 
        wx:class="share-btn {{ isAccelerateShare ? '':'disabled'}}"
        wx:if="{{!isHarmonyos}}"
        bindtap="share">
        <view class="share-btn-title">邀人加速</view>
        <view class="share-btn-text">
          <hl-text
            text="{{inviteText}}"
            commonStyle="{{shareBtnCommomStyle}}"
          />
        </view>
      </view>
      <!-- 右侧加速付费按钮 -->
      <view id="update-btn" class="update-btn" bindtap="handleClick">
        <view class="update-btn-text">直接加速</view>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { getStorage, setStorage } from '@/utils/storage'
  import { SCRAMBLE_ACC_PRE_STATUS } from '@/utils/train-storage'
  import { query, xenv, canIUse, invokeShare, is } from '@didi/webx-js'
  import store from '@/store'
  import { trackEvent } from '@/common/track'
  import { SHARE_ID } from '@/config/falling-popup/constant'
  import { getShareInfo} from '@/api/order-detail/index'
  const speedList =[{
    text:'低速',
    customStatus:0,
  },{
    text:'中速',
    customStatus:1,
  },{
    text:'快速',
    customStatus:2,
  },{
    text:'高速',
    customStatus:3,
  },{
    text:'极速',
    customStatus:4,
  },{
    text:'VIP',
    customStatus:5,
    icon:'https://ut-static.udache.com/webx/sfc/1NgiqriJKiigVYOr70q7a.png',
    activeIcon:'https://ut-static.udache.com/webx/sfc/DUPTFp2feTvZSzpj-nOQg.png'
  }]

  createComponent({
    props: {
      originalProgress: {
        type: Number,
        value: 60
      },
    },
    created() {
      trackEvent('userteam_train_orderdetail_progress_sw','UT-火车票-订单详情页-抢票进度-曝光',{})
      this.getShareInfo()
      this.inited = true
    },
    ready() {
    },
    watch: {
      curProgress: {
        handler(val, old) {
          if (old===undefined) {
            // 刚进入页面 created
            this.progress = this.originalProgress
            setTimeout(() => {
              this.progress = +val <50 ? 60 : (+val < 100? 90 : +val)
            }, 300)
          }else{
            this.progress = +val <50 ? 60 : (+val < 100 ? 90 : +val)
          }
        },
        immediate:true
      },
      progress: {
        handler(val, old) {
          if (val !== old && val) {
            this.diffProgress = val - old 
          }
        }
      }
    },
    data() {
      return {
        inited: false,
        progress: 0,
        hlStyle: {
          color: '#FF6400',
          fontFamily: 'PingFangSC-Medium',
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: '16px',
        },
        commonStyle: {
          color: '#333333',
          fontFamily: 'PingFangSC-Medium',
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: '16px',
        },
        diffProgress: 0,
        shareInfo:{},
        bgImage:'https://ut-static.udache.com/webx/sfc/5hDFsURnpcNJzjMnVTQPz.png'
      }
    },
    computed: {
      ...store.mapState({
        curProgress: 'order.curProgress',
        packageInfo: 'order.package_info',
        baseInfo: 'order.base_info',
      }),
      shareBtnCommomStyle(){
        return {
          color: this.isAccelerateShare ? '#FF5900':'rgba(153, 153, 153, 0.8)'
        }
      },
      isHarmonyos() {
        return is('harmonyos')
      },
      isAccelerateShare(){
        return this.packageInfo?.is_accelerate === 1
      },
      inviteText(){
        return this.packageInfo?.invite_text ?? ''
      },
      title() {
        return this.packageInfo?.title ?? ''
      },
      transitionDuration() {
        const diffLong= 440  //火车头60
        return Number(0.3 + 0.9 * (this.diffProgress / diffLong)).toFixed(2)
      },
      progressStyle() {
        const lg = speedList.length-1
        return {
          width: `${this.progress / lg}%`, 
          transitionDuration: `${this.transitionDuration}s`,
          background: this.progress < 100? 'none':'#ff5800'
        }
      },
      mode(){
        if(+this.progress < 100){
          return "aspectFill"
        }
        return "heightFix"
      },
      picStyle(){
        if(+this.progress < 100){
          return {
            'background-position': 'center right',
            'width': '100%',
            left:0
          }
        }
        return{}
      },
      statusList() {
        const _statusList = speedList.map((item) => {
          item.isActive = this.currentStatus === item.customStatus
          return item
        })
        return _statusList
      },
      currentStatus() {
        // 当前达到的状态索引0-5, 接口返回的是sub-percent 0-100
        return (this.progress / 100) | 0 ?? 1
      },
      highest() {
        return this.currentStatus === 5
      },
      inviteLimit() {
        return this.currentStatus === 3
      },
      containerStyle(){
        const style= this.highest? {
          background: `url(${this.bgImage}) top right/97px 74px no-repeat, linear-gradient(180deg, #FFF4DA 0%, #FFFFFF 53%)`,
        }:{}
        return style
      }
    },
    methods: {
      getShareInfo(){
        const { order_id } = this.$mpxRoute.query
        getShareInfo({
          order_id
        }).then(res => {
          const { data, message, code, success } = res || {}
          if (success && code === '0') {
            this.shareInfo = data
          } else {
          }
        }).catch(err => {
        })
      },
      share() {
        if (!this.isAccelerateShare) return 
        if(is('alipay'))  return mpx.showToast({
          title: '当前环境不支持分享活动', 
          icon: 'error', 
          duration: 2000, 
        });
        trackEvent('userteam_train_orderdetail_speedup_ck','UT-火车票-订单详情页-免费加速按钮-点击')
        const { title, img_url, dchn, poster_url } = this.shareInfo
        const path = `/pages/index/index?dchn=${dchn}&order_id=${this.baseInfo.order_id}&order_uid=${this.baseInfo.order_uid}&share_from=wxappmsg`
        const option = {
          title, 
          img_url, // 微信小程序卡片-图片
          card_content: title, // 微信小程序卡片-标题
          poster_url,
          channels: {
            wx_appmsg: [
              // 分享给微信好友
              {
                xenv: xenv(), // 当前环境xenv与该值相等时 取该配置作为分享配置
                share_type: 'miniApp', // 分享类型
                appid: 'gh_7a5c4141778f', // 分享出的小程序AppId
                miniprogram_type: 0,
                path: path,
              }
            ],
            wx_timeline: [
              // 分享到微信朋友圈
              {
                xenv: xenv(), // 当前环境xenv与该值相等时 取该配置作为分享配置
                share_type: 'image' // 分享类型
              }
            ]
            // ... 如在channels中依次增加channel 则在拉起的面板中对应增加分享Item
          },
          mpShareConfig: {
            share_title: '求助好友为你加速',
            poster_title: '海报已保存到本地相册', 
            poster_sub_title: '去朋友圈分享海报求助力吧'
          },
          activity_id: SHARE_ID,
        }
        canIUse('invokeShare') && invokeShare(option)
      },
      handleClick(){
        this.triggerEvent('packageUpdate')
      },
    }
  })
</script>

<style scoped lang="stylus">
  .accelerate-progress-wrapper
    width 100%
    box-sizing border-box
    background linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(180deg, #FFF3EA 2%, #FFFFFF 27%)
    padding 9px 14px 0 14px
    display flex
    flex-direction column
    border-radius 10px
    margin-bottom 8px
    border 2px solid #FFFFFF
    .status-title
      margin-bottom 13px
    .status-bar
      display flex
      justify-content space-between
      align-items center
      font-family PingFangSC-Regular
      font-size 11px
      font-weight 400
      letter-spacing 0px
      color #666
      margin-bottom 8px
      .status-item
        position relative
        box-sizing border-box
        line-height 12px
        display flex
        align-items center
        z-index 2
        .icon
          height 11px
          margin-right 1.5px
        .line
          position absolute
          left 50%
          bottom -15px
          transform  translate(-50%, 100%)
          height 5px
          width 1px
          border-radius 1px
          background #ff5900
          opacity 0.15
          &.now
            bottom -11px
          &.white
            background #fff
        &.now
          color #FF5900
          font-size 12px
          padding 4px 5.5px
          font-family PingFangSC-Medium
          font-weight 600
    .progress-wrapper
      width 100%
      height 11px
      border-radius 2px
      background #FFEEE6
      margin-bottom 20px
      padding-right 10px
      box-sizing border-box
      position relative
      .progress-bar
        position relative
        height 100%
        border-radius 3.5px 0 0 3.5px
        background #FF5800
        .pic
          height 20px
          position absolute
          top 50%
          right -25px
          transform translateY(-50%)
        &.transition
          transition-property width
          transition-timing-function ease-in-out
    .btn-area
      width 100%
      display flex
      justify-content space-between
      align-items center
      padding-bottom 16px
      .share-btn
        display flex
        align-items center
        justify-content center
        flex-direction column
        padding 0px 15px
        min-width 107px
        height 44px
        box-sizing border-box
        color #FF5900
        font-family: PingFang SC;
        border-radius: 8px;
        background: linear-gradient(0deg, rgba(255, 238, 230, 0.9), rgba(255, 238, 230, 0.9))
        .share-btn-title
          font-size: 14px;
          font-weight: 500;
          line-height: 14px;
          letter-spacing: 0px;
        .share-btn-text
          font-size: 10px;
          font-weight: normal;
          line-height: 12px;
          text-align: center;
          letter-spacing: 0px;
          margin-top 3px
      .share-btn.disabled
        background: linear-gradient(0deg, #E9EFF3, #E9EFF3)
        color: rgba(153, 153, 153, 0.8);
      .update-btn
        height: 44px;
        border-radius: 8px;
        background: #FF5900;
        display flex
        justify-content center
        align-items center
        margin-left 8px
        flex: 1;
        .update-btn-text
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 500;
          line-height: 14px;
          letter-spacing: 0px;
          color: #FFFFFF;

</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'hl-text': '@/components/hl-text'
    }
  }
</script>